import { call, fork, put, takeEvery } from 'redux-saga/effects';
import CsInquiryApi from '../../../../lib/api/cs/inquiry/CsInquiryApi';
import { setRequestForm, setResponseListForm } from '../../../../lib/common.js';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import csInquiryActions from './actions';
import toastMsg from '../../../../lib/toastMsg';
import csInquiryToastMsg from '../../../../constants/service/toastMsg/csInquiryToastMsg';

function* fetchList() {
  /**
   *  [1:1 문의 리스트] 1:1 문의 리스트 요청하기
   */
  yield takeEvery(csInquiryActions.GET_INQUIRY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsInquiryApi.getCsInquiryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csInquiryToastMsg.GET_INQUIRY_LIST_REQUEST_SUCCESS);
        const data = {
          csInquiryList: setResponseListForm(result.data.csInquiryList, result.data.totalCnt, payload),
        };
        yield put({ type: csInquiryActions.GET_INQUIRY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csInquiryToastMsg.GET_INQUIRY_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [1:1 문의 리스트] 1:1 문의 리스트 excel 다운로드 요청하기
   */
  yield takeEvery(csInquiryActions.GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsInquiryApi.getInquiryExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(csInquiryToastMsg.GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [1:1 문의 상세] 1:1 문의 상세 요청하기
   */
  yield takeEvery(csInquiryActions.GET_INQUIRY_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsInquiryApi.getCsInquiryDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csInquiryToastMsg.GET_INQUIRY_DETAIL_REQUEST_SUCCESS);
        const data = {
          inquiryInfo: result.data.inquiryInfo,
          userInfo: {
            ...result.data.userInfo,
            usersOtherInquiry: setResponseListForm(
              result.data.userInfo.usersOtherInquiry.list,
              result.data.userInfo.usersOtherInquiry.totalCnt,
              payload.usersOtherInquiry,
            ),
          },
        };
        yield put({ type: csInquiryActions.GET_INQUIRY_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csInquiryToastMsg.GET_INQUIRY_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [1:1 문의 상세] 유저의 다른 문의 내역 조회하기
   */
  yield takeEvery(csInquiryActions.GET_USERS_OTHER_INQUIRY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsInquiryApi.getCsUsersOtherInquiryList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csInquiryToastMsg.GET_INQUIRY_DETAIL_REQUEST_SUCCESS);

        const data = {
          userInfo: {
            usersOtherInquiry: setResponseListForm(
              result.data.userInfo.usersOtherInquiry.list,
              result.data.userInfo.usersOtherInquiry.totalCnt,
              payload,
            ),
          },
        };

        yield put({ type: csInquiryActions.GET_USERS_OTHER_INQUIRY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csInquiryToastMsg.GET_INQUIRY_DETAIL_REQUEST_ERROR);
    }
  });

  /**
   *  [1:1 문의 상세] 1:1 문의 답변 작성하기
   */
  yield takeEvery(csInquiryActions.REPLY_INQUIRY_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(CsInquiryApi.replyCsInquiryDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(csInquiryToastMsg.REPLY_INQUIRY_DETAIL_REQUEST_SUCCESS);
        const data = {
          answerDate: result.data.answerDate,
          replyAuthor: result.data.replyAuthor,
        };
        yield put({ type: csInquiryActions.REPLY_INQUIRY_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(csInquiryToastMsg.REPLY_INQUIRY_DETAIL_REQUEST_ERROR);
    }
  });
}

export default function* csInquirySaga() {
  yield fork(fetchList);
}
